import React from 'react';
import './invoiceTable.css';
import { useDispatch, useSelector } from "react-redux";
import Tippy from '@tippyjs/react';
import { setSendReceiptFormAction } from "../../redux/rootReducer";
import { SEND_RECEIPT_FORM_INITIAL } from "../../redux/initialStateConstant";

const InvoiceTable = () => {
    const dispatch = useDispatch();
    const invoices = useSelector(state => state.invoices);

    return (
        <div className="invoices">
            <div className="table">
                <div className="table__row table__row--header table__row--invoices">
                    <div className="table__cell">Контрагент</div>
                    {
                        invoices.months.map(elem => (
                            <div className="table__cell" key={ elem.name }>
                                { elem.name }
                                {
                                    elem.count > 0 && elem.rest > 0 &&
                                    <div className="invoices__count">{ elem.count + ' шт. / ' + elem.rest + ' руб.'}</div>
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    invoices.invoices.map((elem, index) => {
                        return(
                            <div
                                key={ index }
                                className="table__row table__row--invoices"
                            >
                                <div className="table__cell">{ elem.app_name }</div>
                                {
                                    Object.keys(elem.invoices).map((el, ind) => {
                                        return (
                                            <div className="table__cell" key={ ind }>
                                                <div className="invoices__data">
                                                    <Tippy content={ elem.invoices[el].payment ? 'Счёт оплачен' : 'Счёт выслан' }>
                                                        <div className={ `invoices__invoice ${ elem.invoices[el].payment ? 'invoices__invoice--payed' : '' }` }>
                                                            { elem.invoices[el].invoice || '' }
                                                        </div>
                                                    </Tippy>
                                                    {
                                                        elem.invoices[el].receipt
                                                            ?
                                                            <Tippy content={ 'Чек выслан' }>
                                                                <div className="invoices__payment invoices__payment--sended" />
                                                            </Tippy>
                                                            :
                                                            <Tippy content={ 'Выслать чек' }>
                                                                <div className="invoices__send-receipt"
                                                                     onClick={ () => {
                                                                         // Открываем форму отправки чека
                                                                         dispatch(setSendReceiptFormAction({
                                                                             ...SEND_RECEIPT_FORM_INITIAL,
                                                                             open: true,
                                                                             invoice_id: elem.invoices[el].id,
                                                                             counterparty_id: elem.counterparty_id,
                                                                             period: elem.invoices[el].date
                                                                         }));
                                                                     } }
                                                                />
                                                            </Tippy>
                                                    }

                                                </div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default InvoiceTable;